module.exports = __webpack_public_path__ + "img/shop.5f892265.png";